import React from "react";

/* img imports */
import broccoliItemSelect from "../../assets/games/tower-game/tower-game-characters/broccoli-item-select.png";
import broccoliLevelComplete from "../../assets/games/tower-game/tower-game-characters/broccoli-level-complete.png";
import broccoliTowerFell from "../../assets/games/tower-game/tower-game-characters/broccoli-tower-fell.png";
import carrotItemSelect from "../../assets/games/tower-game/tower-game-characters/carrot-item-select.png";
import carrotLevelComplete from "../../assets/games/tower-game/tower-game-characters/carrot-level-complete.png";
import carrotTowerFell from "../../assets/games/tower-game/tower-game-characters/carrot-tower-fell.png";
import towerGameShelf from "../../assets/games/tower-game/tower-game-shelf.png";
import towerLevel1Text from "../../assets/games/tower-game/tower-level-1-text.png";
import towerLevel2Text from "../../assets/games/tower-game/tower-level-2-text.png";
import towerLevel3Text from "../../assets/games/tower-game/tower-level-3-text.png";
import towerLevelWonText from "../../assets/games/tower-game/tower-level-won-text.png";
import towerGameOverText from "../../assets/games/tower-game/tower-game-over-text.png";
import towerGameCompleteText from "../../assets/games/tower-game/tower-game-complete-text.png";
import towerSelectItemsText from "../../assets/games/tower-game/tower-select-items-text.png";
import clickPointer from "../../assets/games/tower-game/click-pointer.png";
import gameCompleteCertificate from "../../assets/games/tower-game/level-complete-certificate.png";

/* data imports */
import towerItemsImagesObj from "../game-data/towerItemsImagesObj";

const TowerLeftArea = ({
  itemHoverHandler,
  hoveredItem,
  levelItemsData,
  itemSelectorHandler,
  selectedItems,
  selectedItemFlag,
  gameLevel,
  isGameOver,
  restartGame,
  isLevelWin,
  startNextLevel,
  isGameComplete,
  gameCompleteHandler,
}) => {
  return (
    <>
      <div className="game-top-wrapper">
        {levelItemsData.length > 0 &&
          levelItemsData.map((val, i) => {
            let valId = val.id;
            let itemExist = selectedItems.filter((item) => item.id === valId);
            return (
              <div
                key={i}
                className={`food-item ${
                  itemExist.length > 0 ? "selected" : ""
                }`}
                onMouseOver={() => itemHoverHandler(val.header)}
                onMouseOut={() => itemHoverHandler("")}
                onClick={() => itemSelectorHandler(val)}
              >
                {/* {val.header} */}
                <img src={towerItemsImagesObj[val.imageLink]} alt="" />
              </div>
            );
          })}

        <div className="tower-shelf-1">
          <img src={towerGameShelf} alt="Shelf" />
        </div>
        <div className="tower-shelf-2">
          <img src={towerGameShelf} alt="Shelf" />
        </div>
        <div className="tower-shelf-3">
          <img src={towerGameShelf} alt="Shelf" />
        </div>
        <div className="tower-item-name">{hoveredItem}</div>
      </div>
      <div className="game-left-wrapper">
        <img
          src={
            isLevelWin
              ? carrotLevelComplete
              : isGameOver
              ? carrotTowerFell
              : isGameComplete
              ? carrotLevelComplete
              : carrotItemSelect
          }
          alt="carrot"
        />
      </div>
      <div className="game-table-wrapper">
        <div className="game-table"></div>
        <div className="game-tower-wrapper">
          {selectedItems.length > 0 &&
            selectedItems.map((val, i) => (
              <div key={i} className={`tower-block`}>
                <picture>
                  <img
                    src={towerItemsImagesObj[val.imageLink]}
                    alt={val.header}
                  />
                </picture>
              </div>
            ))}
          {isGameOver && (
            <div className="tower-fell">
              <div className="tower-fell-image-wrapper"></div>
            </div>
          )}
          <div className="tower-complete">
            <div className="tower-complete-image-wrapper">
              <picture className={isGameComplete ? "active" : ""}>
                <img src={gameCompleteCertificate} alt="Game Certificate" />
              </picture>
            </div>
          </div>
        </div>

        <div
          className="tower-game-message"
          onClick={
            isLevelWin
              ? startNextLevel
              : isGameOver
              ? restartGame
              : isGameComplete
              ? gameCompleteHandler
              : null
          }
        >
          <img
            src={
              isLevelWin
                ? towerLevelWonText
                : isGameComplete
                ? towerGameCompleteText
                : isGameOver
                ? towerGameOverText
                : towerSelectItemsText
            }
            alt="Message Board"
          />
          {isLevelWin || isGameComplete || isGameOver ? (
            <div className="click-pointer">
              <img src={clickPointer} alt="Click Pointer" />
            </div>
          ) : null}
        </div>

        <div className="tower-game-level">
          <img
            src={
              gameLevel === 1
                ? towerLevel1Text
                : gameLevel === 2
                ? towerLevel2Text
                : towerLevel3Text
            }
            alt="Level Board"
          />
        </div>
      </div>
      <div className="game-right-wrapper">
        <img
          src={
            isLevelWin
              ? broccoliLevelComplete
              : isGameOver
              ? broccoliTowerFell
              : isGameComplete
              ? broccoliLevelComplete
              : broccoliItemSelect
          }
          alt="Broccoli"
        />
      </div>
    </>
  );
};

export default TowerLeftArea;
